<template>
  <b-form-radio-group
    v-model="selected"
    :options="options"
    value-field="item"
    text-field="name"
    disabled-field="notEnabled"
  />
</template>

<script>
export default {
  props: ['options', 'preSelected', 'traitType'],
  data() {
    return {
      selected: ''
    };
  },
  watch: {
    selected() {
      if (!this.traitType) {
        this.$emit('selectRadio', this.selected);
      } else {
        this.$emit('selectRadio', this.traitType, this.selected);
      }
    },
    preSelected() {
      if (this.preSelected !== this.selected) {
        this.selected = this.preSelected;
      }
    }
  },
  mounted() {
    if (this.preSelected) {
      this.selected = this.preSelected;
    }
  },
  methods: {
    resetValue() {
      this.selected = '';
    }
  }
};
</script>

<style lang="scss" scoped>
::v-deep .custom-control-input:checked ~ .custom-control-label::before {
  border-color: #5b6ef5;
  background-color: #5b6ef5;
}

::v-deep .custom-control-label {
  cursor: pointer;
  font-family: Inter-Regular;
  font-size: 16px;
  color: #828c9f;
}
</style>
